import * as yup from "yup";

const deleteSchema = (translate: Function) => yup.object().shape({
	efa001Fantasia: yup.string().required(translate("Nome do grupo não confere")).oneOf([yup.ref("efa001FantasiaConfirmation")], translate("Nome do grupo não confere"))
});

const addAndChangeSchema = (translate: Function) => yup.object().shape({
	efa001Grupo: yup.number().typeError(translate("Grupo é requerido")).required(translate("Grupo é requerido")),
	efa001Razao: yup.string().required(translate("Razão social é requerido")),
	efa001Fantasia: yup.string().required(translate("Nome fantasia é requerido"))
});

const addPlanSchema = (translate: Function) => yup.object().shape({
	efd001Id: yup.string().required(translate("Plano comercial é requerido")),
	efa012Dtvalini: yup.date().required(translate("Data inicial é requerida"))
});

const revalidatePlanSchema = (translate: Function) => yup.object().shape({
	efa012Dtvalini: yup.date().required(translate("Data inicial é requerida"))
});

const addChangeContractItemSchema = (translate: Function) => yup.object().shape({
	efa012Tipo: yup.string().required(translate("Tipo é requerido")),
	efa012Valor: yup.string().required(translate("Valor é requerido"))
});

export { deleteSchema, addAndChangeSchema, addPlanSchema, addChangeContractItemSchema, revalidatePlanSchema };
